/*
 * Intake info/name card for CreateEditIntakeView. Wraps the card chrome + the
 * Task-6 CreateNewIntakeFormInfo name field. Header label differs by mode:
 *   edit:   "Intake information"
 *   create: "Intake info"
 *
 * SCSS → Tailwind mapping (ceiv-card*):
 *   .ceiv-card: bg:#fff / border:1px solid --border-card(#141E1F1A) / radius:8px / overflow:hidden
 *     → bg-white border border-shade-10 rounded-large overflow-hidden
 *   .ceiv-card-header: flex / items-center / gap:10px / padding:16px 24px / border-bottom:1px solid --border-card
 *     → flex items-center gap-[10px] py-sp-2 px-sp-3 border-b border-shade-10
 *   .ceiv-card-header-title: font-size:14px / font-weight:600 / color:--text-dark
 *     → text-size-3 font-semibold text-text-dark
 *   .ceiv-card-body: padding:24px → p-sp-3
 *
 * Arbitrary values: gap-[10px] (10px, no DS token).
 */
import { CreateNewIntakeFormInfo } from '../../CreateNewIntakeFormInfo/CreateNewIntakeFormInfo'

type Props = {
  isEdit?: boolean | undefined
  onSetIntakeFormNameValue: (value: string) => void
  newIntakeFormNameValue: string
  newIntakeFormNameError: boolean
  newIntakeFormNameLocalError: string
}

export function IntakeNameCard({
  isEdit,
  onSetIntakeFormNameValue,
  newIntakeFormNameValue,
  newIntakeFormNameError,
  newIntakeFormNameLocalError,
}: Props) {
  return (
    <div className='overflow-hidden rounded-large border border-shade-10 bg-white'>
      <div className='flex items-center gap-[10px] border-b border-shade-10 px-sp-3 py-sp-2'>
        <span className='text-size-3 font-semibold text-text-dark'>
          {isEdit ? 'Intake information' : 'Intake info'}
        </span>
      </div>
      <div className='p-sp-3'>
        <CreateNewIntakeFormInfo
          onSetIntakeFormNameValue={onSetIntakeFormNameValue}
          newIntakeFormNameError={newIntakeFormNameError}
          newIntakeFormNameLocalError={newIntakeFormNameLocalError}
          newIntakeFormNameValue={newIntakeFormNameValue}
          isEdit={isEdit}
        />
      </div>
    </div>
  )
}
